import { all  } from 'redux-saga/effects'
import MarcatoriSaga from './marcatori/saga';
import IppicaSaga from './ippica/saga';

export default function* rootSaga() {
  yield all([
    MarcatoriSaga(),
    IppicaSaga(),
  ])
}